export const EVENT_TEMPLATE_OWNERS = {
  DEFAULT: 'default',
  FORECAST: 'forecast',
  HEALTH_BENEFITS: 'health-benefits',
  PREFIX_MANAGEMENT: 'prefix-management',
  USERS: 'users',
  LEGAL_MANAGEMENT: 'legal-management',
  PICKUP_ETA: 'pickup-eta',
  PARKING_MANAGEMENT: 'parking-management',
  CLIENT: 'client',
};

export const EVENT_TEMPLATE_TARGETS = {
  DEFAULT: 'default',
  DASHBOARD_APP: 'dashboard-app',
};
